module.exports = __webpack_public_path__ + "img/smile.e9b888cc.svg";